/* @flow */

export type Action =
  | { type: 'FILTER_RESOURCES' }
  | { type: 'UPDATE_RESOURCE' }
  | { type: 'REMOVE_RESOURCE' }
  | { type: 'REMOVE_RESOURCE_SUCCESS' };

export const filterResources = (value: string): Action => ({
  type: 'FILTER_RESOURCES',
  value,
});

export const updateResource = (resource: BucketResource): Action => ({
  type: 'UPDATE_RESOURCE',
  resource,
});

export const removeResource = (resource: BucketResource): Action => ({
  type: 'REMOVE_RESOURCE',
  resource,
});

export const removeResourceSuccess = (resourceId: string): Action => ({
  type: 'REMOVE_RESOURCE_SUCCESS',
  resourceId,
});



// WEBPACK FOOTER //
// ./src/modules/bucket/actions/resources.js